import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";

export const AddParterForm = async (params) => {
  const url = `${BaseUrl}/InsertBecomeAPartner`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
